export const state = () => ({
  isMonitoredSwitchOn: false
});

export const mutations = {
  setIsMonitoredSwitchOn(state, isMonitoredSwitchOn) {
    state.isMonitoredSwitchOn = isMonitoredSwitchOn;
  }
};

export const actions = {
  /**
   * Handles the monitored toggle to filter reports that are being monitored.
   *
   * @param {function} commit
   * @param {boolean} isMonitoredSwitchOn
   * @returns {void}
   */
  handleMonitoredToggle({ commit }, isMonitoredSwitchOn) {
    commit('setIsMonitoredSwitchOn', isMonitoredSwitchOn);
  }
};

export const getters = {
  isMonitoredSwitchOn: state => state.isMonitoredSwitchOn
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
